import { Table } from "@project/shared"
import { t } from "i18next"
import { CityNumber } from "./common/CityNumber"
import { BeneficiaryNumber } from "./common/BeneficiaryNumber"
import { ParentName } from "./common/ParentName"
import { ChildName } from "./common/ChildName"
import { PRINT_CONFIGURATION_OPTION_VALUES } from "../../../../../constants"
import { SiblingChild } from "../../../../../types"

type Props = {
  municipalityNumber: string
  parentName: string
  siblingChildren: SiblingChild[]
  printConfig: string[]
}

export function DefaultChildDetail({
  municipalityNumber,
  parentName,
  siblingChildren,
  printConfig,
}: Props) {
  const CITY_NUMBER_INDEX = 0
  const BENEFICIARY_NUMBER_INDEX = 1
  const PARENT_NAME_INDEX = BENEFICIARY_NUMBER_INDEX + siblingChildren.length
  const CHILD_NAME_INDEX = PARENT_NAME_INDEX + 1
  const BOTTOM_INDEX = CHILD_NAME_INDEX + siblingChildren.length - 1

  return (
    <Table
      columns={[
        {
          width: "150px",
          onCell: (_, index) => {
            // 児童名・受給者証番号 の 行結合
            if (
              index === BENEFICIARY_NUMBER_INDEX ||
              index === CHILD_NAME_INDEX
            ) {
              return { rowSpan: siblingChildren.length }
            }

            // 児童名・受給者証番号 の 不要行を削除
            if (
              (BENEFICIARY_NUMBER_INDEX < index && index < PARENT_NAME_INDEX) ||
              (CHILD_NAME_INDEX < index && index <= BOTTOM_INDEX)
            ) {
              return { rowSpan: 0 }
            }

            return {}
          },
          render: (_, __, index) => {
            if (index === CITY_NUMBER_INDEX) {
              return <p>{t("Provision city No.")}</p>
            }

            if (index === BENEFICIARY_NUMBER_INDEX) {
              return <p>{t("Beneficiary no.")}</p>
            }

            if (index === PARENT_NAME_INDEX) {
              const parentName = printConfig.includes(
                PRINT_CONFIGURATION_OPTION_VALUES.CHANGE_DISABILITY_WORD
              )
                ? t(
                    "Name of person with a disability for whom payment has been decided"
                  )
                : t(
                    "Name of person with a disability, etc. whose payment is determined"
                  )
              return <p>{parentName}</p>
            }

            if (index === CHILD_NAME_INDEX) {
              const childName = printConfig.includes(
                PRINT_CONFIGURATION_OPTION_VALUES.CHANGE_DISABILITY_WORD
              )
                ? t(
                    "Name of child with a disability related to payment decision "
                  )
                : t(
                    "Name of child with a disability related to payment decision"
                  )
              return <p>{childName}</p>
            }

            return <></>
          },
        },

        {
          width: "335px",
          dataIndex: "value",
          render: (text) => <p>{text}</p>,
        },
      ]}
      dataSource={[
        // 市区町村番号
        { value: <CityNumber number={municipalityNumber} /> },
        // 支給決定障害者等氏名
        ...siblingChildren.map(
          ({ child_id, receiving_certificate_number }) => ({
            value: (
              <BeneficiaryNumber
                key={child_id}
                number={receiving_certificate_number}
              />
            ),
          })
        ),
        // 支給決定障害者等氏名
        { value: <ParentName name={parentName} configuration={printConfig} /> },
        // 支給決定に係る障害児氏名
        ...siblingChildren.map(({ child_id, child_name }) => ({
          value: (
            <ChildName
              key={child_id}
              name={child_name}
              configuration={printConfig}
            />
          ),
        })),
      ]}
      pagination={false}
      showHeader={false}
    />
  )
}
